import { render, staticRenderFns } from "./homeInfo.vue?vue&type=template&id=232a63d0&scoped=true&"
import script from "./homeInfo.vue?vue&type=script&lang=js&"
export * from "./homeInfo.vue?vue&type=script&lang=js&"
import style0 from "./homeInfo.vue?vue&type=style&index=0&id=232a63d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a63d0",
  null
  
)

export default component.exports